module.exports = __webpack_public_path__ + "static/media/CV.bdf9a562.pdf";